import { render, staticRenderFns } from "./QuotaExplain.vue?vue&type=template&id=7f3c63ba&scoped=true"
import script from "./QuotaExplain.vue?vue&type=script&lang=js"
export * from "./QuotaExplain.vue?vue&type=script&lang=js"
import style0 from "./QuotaExplain.vue?vue&type=style&index=0&id=7f3c63ba&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3c63ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f3c63ba')) {
      api.createRecord('7f3c63ba', component.options)
    } else {
      api.reload('7f3c63ba', component.options)
    }
    module.hot.accept("./QuotaExplain.vue?vue&type=template&id=7f3c63ba&scoped=true", function () {
      api.rerender('7f3c63ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/dashboard/analysis/QuotaExplain.vue"
export default component.exports